/* eslint-disable no-return-await, no-console, no-param-reassign, no-trailing-spaces */
import axios from 'axios';
import moment from 'moment';
import helper from '@/_libs/helper';

const DATE_TODAY = moment().format('YYYY-MM-DD');

// const DATE_YESTERDAY = moment().subtract(1, 'days').format('YYYY-MM-DD');
// const DATE_3_DAYS_AGO = moment().subtract(3, 'days').format('YYYY-MM-DD');
// const DATE_LASTWEEK = moment().subtract(7, 'days').format('YYYY-MM-DD');

// const DATE_TOMORROW = moment().add(1, 'days').format('YYYY-MM-DD');

// const CURRENT_TIME = new Date().getTime();

const COL_TYPE = {
  Date,
  Number,
  Time: 'Time',
  OrderStatus: 'OrderStatus',
  ShipmentStatus: 'ShipmentStatus',
  BackOrderStatus: 'BackOrderStatus',
};
const ORDER_STATUS = {
  PENDING: 0,
  APPROVED: 1,
  REJECTED: 2,
  UNIX: 3,
};
const SHIPMENT_STATUS = {
  PENDING: 0,
  DELIVERED: 1,
  REJECTED: 2,
};
const BACK_ORDER_STATUS = {
  WAITING: 0,
  READY: 1,
  CANCELLED: 2,
};

const EXTENDED_STAT_MOCK = {
  overLimitPercentage: 5,
  remainingQuota: -10000,

  outstandingBillCount: 1,
  chequeCount: {
    total: 5,
    thisYear: 4,
  },

  customerType: 2562,
  lifetimeSpends: 98000.56,

  advanceChequeAmount: 20000,
};
const CUSTOMERS = [
  {
    id: 1,
    name: 'บริษัท เอ จำกัด',
    image: 'http://placekitten.com/128/128',
    province: 'bkk',
    zone: 'NE',
    balance: 50000.00,
    grade: 'b',
    
    address: '120/1 ม.1 ต.องครักษ์ อ.องครักษ์ จ.นครนายก 26120',
    phone: '0897654321',
    unpaid: {
      count: 30,
      total: 56000000.00,
    },
    remaining: 15000,
    mostExpensiveCheque: 15000,

    extendedStat: EXTENDED_STAT_MOCK,
  },
  {
    id: 2,
    name: 'บริษัท บี จำกัด (มหาชน)',
    image: 'http://placekitten.com/128/128',
    province: 'cnx',
    zone: 'NE',
    balance: 60000.00,
    grade: 'c',

    address: '120/1 ม.1 ต.องครักษ์ อ.องครักษ์ จ.นครนายก 26120',
    phone: '0812345678',
    unpaid: {
      count: 10,
      total: 2000000.00,
    },
    remaining: 15000,
    mostExpensiveCheque: 15000,

    extendedStat: EXTENDED_STAT_MOCK,
  },
  {
    id: 3,
    name: 'บริษัท ซี จำกัด (มหาชน)',
    image: 'http://placekitten.com/128/128',
    province: 'cnx',
    zone: 'NE',
    balance: 60000.00,
    grade: 'a',

    address: '120/1 ม.1 ต.องครักษ์ อ.องครักษ์ จ.นครนายก 26120',
    phone: '0812345678',
    unpaid: {
      count: 10,
      total: 2000000.00,
    },
    remaining: 15000,
    mostExpensiveCheque: 15000,

    extendedStat: EXTENDED_STAT_MOCK,
  },
  {
    id: 4,
    name: 'บริษัท ดี จำกัด (มหาชน)',
    image: 'http://placekitten.com/128/128',
    province: 'cnx',
    zone: 'NE',
    balance: 60000.00,
    grade: 'b',

    address: '120/1 ม.1 ต.องครักษ์ อ.องครักษ์ จ.นครนายก 26120',
    phone: '0812345678',
    unpaid: {
      count: 10,
      total: 2000000.00,
    },
    remaining: 15000,
    mostExpensiveCheque: 15000,

    extendedStat: EXTENDED_STAT_MOCK,
  },
];

const SELLERS = [
  { name: 'John' },
  { name: 'Jack' },
  { name: 'Martha' },
  { name: 'Rose' },
];

const MOCK = {
  provinces: [
    { id: 'bkk', name: 'กรุงเทพฯ' },
    { id: 'cnx', name: 'เชียงใหม่' },
  ],
  customers: CUSTOMERS,
  insight: {
    recent: [ 
      {
        dueDate: DATE_TODAY,
        productCode: 'D6XN5CM',
        productName: 'ไม้อัด ตรากระต่าย',
        amount: 1,
        price: 69000.46,
        total: 69000.46,
      },
      {
        dueDate: DATE_TODAY,
        productCode: '3D6XN5C',
        productName: 'item 2',
        amount: 2,
        price: 69000.46,
        total: 69000.46 * 2,
      },
      {
        dueDate: DATE_TODAY,
        productCode: 'D6XN5CM',
        productName: 'ไม้อัด ตรากระต่าย',
        amount: 1,
        price: 69000.46,
        total: 69000.46,
      },
      {
        dueDate: DATE_TODAY,
        productCode: '3D6XN5C',
        productName: 'item 3',
        amount: 2,
        price: 69000.46,
        total: 69000.46 * 2,
      },
      {
        dueDate: DATE_TODAY,
        productCode: '3D6XN5C',
        productName: 'item 4',
        amount: 2,
        price: 69000.46,
        total: 69000.46 * 2,
      },
    ],
    unpaid: [ 
      {
        dueDate: DATE_TODAY,
        documentCode: 'D6XN5CM3',
        customerName: 'บริษัท ลิ้มเจริญค้าวัสดุก่อสร้าง จำกัด',
        total: 69000.46 * 2,
        overDueDateCount: 2,
      },
      {
        dueDate: DATE_TODAY,
        documentCode: 'D6XN5CH8',
        customerName: 'บริษัท ลิ้มเจริญค้าวัสดุก่อสร้าง จำกัด',
        total: 55555.55,
        overDueDateCount: 1,
      },
      {
        dueDate: DATE_TODAY,
        documentCode: 'TD5IA2',
        customerName: 'บริษัท ลิ้มเจริญค้าวัสดุก่อสร้าง จำกัด',
        total: 69000.46 * 2,
        overDueDateCount: 2,
      },
      {
        dueDate: DATE_TODAY,
        documentCode: '0SR674DM',
        customerName: 'บริษัท ลิ้มเจริญค้าวัสดุก่อสร้าง จำกัด',
        total: 69000.46 * 2,
        overDueDateCount: 2,
      },
      {
        dueDate: DATE_TODAY,
        documentCode: '0SR123',
        customerName: 'บริษัท ลิ้มเจริญค้าวัสดุก่อสร้าง จำกัด',
        total: 55555.55,
        overDueDateCount: 1,
      },
    ],
  },
};

const customer = {
  async provincesList() {
    return await helper.call('customer.provinces.list', {
      success: true,
      data: MOCK.provinces,
    }, async () => await axios(helper.path('customer/provinces/list')));
  },
  async list() {
    return await helper.call('customer.list', {
      success: true,
      data: MOCK.customers,
    }, async () => await axios(helper.path('customer/list')));
  },
  // async getById(id) {
  //   /* eslint-disable-next-line */
  //   const searchResult = MOCK.customers.filter((item) => {
  //     return item.id === id;
  //   });
  //   return await helper.call('customer.by-id', {
  //     success: true,
  //     data: (searchResult ? searchResult[0] : {}),
  //   }, async () => await axios(helper.path('customer/by-id')));
  // },
  // async insight(id) {
  //   console.log(id);
  //   return await helper.call('customer.insight', {
  //     success: true,
  //     data: MOCK.insight,
  //   }, async () => await axios(helper.path('customer/insight')));
  // },

  COL_TYPE,
  ORDER_STATUS,
  SHIPMENT_STATUS,
  BACK_ORDER_STATUS,

  // MOCK
  CUSTOMERS,
  SELLERS,
};

export default customer;
